
export const userAdmin = {
  profile: {
    title: "Profile Information",
    displayName: "Display name",
    email: "Email address",
    accountCreated: "Account created",
    lastLogin: "Last login",
    updateProfile: "Save profile",
    updating: "Updating...",
    notifications: "Notification Settings",
    emailNotifications: "Email notifications",
    emailNotificationsDesc: "Receive notifications about your purchased services",
    promotionalEmails: "Promotional emails",
    promotionalEmailsDesc: "Receive notifications about promotions and special offers",
    platformUpdates: "Platform updates",
    platformUpdatesDesc: "Receive notifications about platform news and updates",
    security: "Security",
    passwordChange: "Password change",
    passwordChangeDesc: "Update your password for account security",
    changePassword: "Change password",
    logout: "Logout",
    logoutDesc: "Sign out from your account",
    logoutButton: "Sign out"
  },
  dashboard: {
    welcomeTitle: "Welcome to Your Dashboard",
    welcomeDescription: "This is your central hub for all your account activities. From here, you can view and manage your profile, purchases, scheduled appointments, personal video requests, and communications with creators.",
    bespireExplanation: "In this interface, you can manage all your content, services, and communications purchased from creators on the Bespire platform. All your purchases, appointments, and personal messages are available in one place.",
    quickAccessTitle: "Quick Access",
    helpSectionTitle: "Need Help?",
    helpSectionDescription: "If you have any questions or need assistance with your account, check our FAQ or contact our support team.",
    faqLinkText: "Frequently Asked Questions",
    contactLinkText: "Contact Support",
    faqSectionTitle: "Frequently Asked Questions",
    faqDialogTitle: "Frequently Asked Questions",
    menuDescriptions: {
      profil: "Manage your personal information, account settings, and notification preferences",
      vásárlások: "View your purchase history and access your bought digital content",
      időpontok: "Manage your scheduled appointments with creators",
      "videó kérések": "Check the status of your personal video requests",
      kérdéseim: "View your questions and responses from creators",
      workshopjaid: "View workshops you've purchased tickets for"
    }
  },
  workshops: {
    title: "Your Workshops",
    description: "Here you can see all workshops you've purchased tickets for.",
    upcomingWorkshops: "Upcoming Workshops",
    pastWorkshops: "Past Workshops",
    noUpcomingWorkshops: "You have no upcoming workshops.",
    noPastWorkshops: "You have no past workshops.",
    name: "Name",
    date: "Date",
    time: "Time",
    location: "Location",
    price: "Price",
    online: "Online",
    physical: "Physical",
    attendees: "Attendees"
  }
};
